

















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import moment from 'moment';
import Availability from '@/models/Availability.ts';
import Room from '@/models/Room.ts';
import BoxRoomStatus from '@/components/BoxRoomStatus.vue';
import BoxRoomAvailability from '@/components/BoxRoomAvailable.vue';
import BoxRoomBooking from '@/components/BoxRoomBooking.vue';
import DropdownRoomStatus from '@/components/dropdowns/DropdownRoomStatus.vue';
import BoxRoomPrice from '@/components/BoxRoomPrice.vue';
import AppTooltip from '@/components/AppTooltip.vue';
import ChannelManagerPromo from '@/components/ChannelManagerPromo.vue';
import { getCurrencySymbol } from '@/utils/utils';
import BoxRoomBaseRate from '@/components/BoxRoomBaseRate.vue';

const DEFAULT_ROWS = 2;

@Component({
  computed: mapState({
    dateRange: (state: any) => state.dashboard.dateRange,
    transitionType: (state: any) => state.dashboard.transitionType,
    isOnRequest: (state: any) => state.dashboard.isOnRequest,
  }),
  components: {
    BoxRoomBaseRate,
    BoxRoomStatus,
    BoxRoomAvailability,
    BoxRoomBooking,
    BoxRoomPrice,
    DropdownRoomStatus,
    AppTooltip,
    ChannelManagerPromo,
  },
})
export default class RoomTable extends Vue {
  @Prop() public readonly room!: Room;
  @Prop() public readonly whatFixTable!: boolean;
  public data: Room = new Room();
  public dateRange: any;
  public dropdown: any;
  public currencySymbol = getCurrencySymbol(this.room.currencyCode);
  public transitionType!: string;

  private readonly isOnRequest!: boolean;

  public showBulkUpdateModal() {
    this.$store.commit('setSelectedRoom', this.data);
    this.$store.dispatch('toggleModal', 'bulkUpdate');
  }

  public get numRows() {
    let rows: number = DEFAULT_ROWS;
    if (this.data.pricingEnabled) { rows++; }
    if (!this.isOnRequest) { rows++; }
    if (this.partnerHasVariablePricing) { rows++; }
    return rows;
  }

  public get variablePricingEnabled() {
    return process.env.VUE_APP_VARIABLE_PRICING_ENABLED === '1';
  }

  public get partnerHasVariablePricing() {
    return this.variablePricingEnabled && Vue.prototype.$PARTNER_HAS_VARIABLE_PRICING;
  }

  public get partnerPricingTooltip() {
    if (this.partnerHasVariablePricing) {
      return this.$t('rooms.pricesTip') + ' ' + this.$t('rooms.variablePricingExtraTooltip');
    }

    return this.$t('rooms.variablePricingExtraTooltip');
  }

  /* istanbul ignore next */
  get bulkUpdateEnabled() {
    return this.$store.getters.isBulkUpdateEnabled;
  }

  get visibleAvailabilities() {
    return this.data.availabilities.filter((availability: Availability) => {
      return moment(availability.date).isBetween(
        this.dateRange.start,
        this.dateRange.end,
        'days',
        '[]',
      );
    }).sort((a: Availability, b: Availability) => {
      return moment(a.date).diff(b.date, 'days');
    }) || [];
  }

  get visibleBookings() {
    return this.data.bookings.filter((booking: any) => {
      return moment(booking.date).isBetween(
        this.dateRange.start,
        this.dateRange.end,
        'days',
        '[]',
      );
    }).sort((a: any, b: any) => {
      return moment(a.date).diff(b.date, 'days');
    }) || [];
  }

  get visibleBaseRates() {
    return this.data.prices.filter((price: any) => {
      return moment(price.date).isBetween(
        this.dateRange.start,
        this.dateRange.end,
        'days',
        '[]',
      );
    }).sort((a: any, b: any) => {
      return moment(a.date).diff(b.date, 'days');
    }).map((item: any) => (item.baseRate)) || [];
  }
  get visiblePrices() {
    return this.data.prices.filter((price: any) => {
      return moment(price.date).isBetween(
        this.dateRange.start,
        this.dateRange.end,
        'days',
        '[]',
      );
    }).sort((a: any, b: any) => {
      return moment(a.date).diff(b.date, 'days');
    }) || [];
  }

  get tableCanBeDisplayed() {
    return this.data.pricingEnabled
      ? this.visibleAvailabilities.length && this.visibleBookings.length && this.visiblePrices.length
      : this.visibleAvailabilities.length && this.visibleBookings.length;
  }

  public isFirstElement(index: number) {
    return this.whatFixTable && !index;
  }

  protected mounted() {
    this.data = this.$props.room;
  }

  @Watch('room', { immediate: true })
  private onRoomChange(value: Room, oldVal: Room) {
    if (value !== oldVal) {
      this.data = value;
    }
  }
}
